import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import SubmitButton from "../../UtilFormInputs/SubmitButton/SubmitButton.component";
import PasswordInput from "../../UtilFormInputs/PasswordInput/PasswordInput.component";
import ValidationPill from "./ValidationPill/ValidationPill.component";
import { validationPillStrings } from "./ValidationPill/ValidationPill.string";
import "./SignupForm.scss";
import { enhancedInput } from "../../../../../../components/utils/InputHOC/InputHOC";
import BaseInputComponent from "../../../../../../components/utils/InputHOC/BaseInputComponent.component";
import { baseInputStrings } from "../../../../../../components/utils/InputHOC/BaseInput.strings";
import SubmitButtonExistAccount from "../../UtilFormInputs/SubmitButton/SubmitButtonExistAccount.component";

export interface SignupFormProps {
    onSubmit?: (credentials) => {};
    onChangePage: any;
}

const initialValues = {
    email: "",
    firstName: "",
    lastName: "",
    password: ""
};

const MIN_PASS_LENGTH = 8;
const LOWER_CASE_REGEX = /(?=.*[a-z])/;
const UPPER_CASE_REGEX = /(?=.*[A-Z])/;
const DIGIT_REGEX = /(?=.*\d)/;
const SYMBOL_REGEX = /[-!$#%^&*@()_+|~=`{}\[\]:";'<>?,.\/]/;

const validationSchema = Yup.object().shape({
    email: Yup.string()
        .email("e-mail is not valid")
        .required("e-mail is required"),
    firstName: Yup.string().required("first name is required"),
    lastName: Yup.string().required("last name is required"),
    password: Yup.string()
        .required("Password is required")
        .matches(LOWER_CASE_REGEX, "Password must contain lower case character")
        .matches(UPPER_CASE_REGEX, "Password must contain upper case character")
        .matches(DIGIT_REGEX, "Password must contain digit")
        .matches(SYMBOL_REGEX, "Password must symbol (@$%*?&)")
        .min(MIN_PASS_LENGTH, `MIN_LENGTH{${MIN_PASS_LENGTH}}`)
});

export default class SignupForm extends Component<SignupFormProps, {}> {
    render() {
        const emailInput = enhancedInput({
            WrappedComponent: BaseInputComponent,
            id: "Email",
            placeholder: baseInputStrings.EMAIL,
            inputType: "email"
        });

        const firstNameInput = enhancedInput({
            WrappedComponent: BaseInputComponent,
            id: "FirstName",
            placeholder: baseInputStrings.FIRST_NAME,
            inputType: "text"
        });

        const lastNameInput = enhancedInput({
            WrappedComponent: BaseInputComponent,
            id: "LastName",
            placeholder: baseInputStrings.LAST_NAME,
            inputType: "text"
        });

        return (
            <div className="auth-form">
                <Formik
                    initialValues={initialValues}
                    onSubmit={values => this.props.onSubmit(values)}
                    validationSchema={validationSchema}
                    render={props => {
                        return (
                            <Form>
                                <Field
                                    className="auth-form-input"
                                    name="email"
                                    component={emailInput}
                                />
                                <Field
                                    className="auth-form-input"
                                    name="firstName"
                                    component={firstNameInput}
                                />
                                <Field
                                    className="auth-form-input"
                                    name="lastName"
                                    component={lastNameInput}
                                />
                                <Field
                                    className="auth-form-input"
                                    name="password"
                                    component={PasswordInput}
                                />
                                <div id="password-validators-container">
                                    <ValidationPill
                                        pattern={DIGIT_REGEX}
                                        caption={validationPillStrings.DIGITS}
                                        currentPassword={props.values.password}
                                    />
                                    <ValidationPill
                                        pattern={LOWER_CASE_REGEX}
                                        caption={
                                            validationPillStrings.LOWER_CASE
                                        }
                                        currentPassword={props.values.password}
                                    />
                                    <ValidationPill
                                        pattern={SYMBOL_REGEX}
                                        caption={validationPillStrings.SYMBOLS}
                                        currentPassword={props.values.password}
                                    />
                                    <ValidationPill
                                        pattern={UPPER_CASE_REGEX}
                                        caption={
                                            validationPillStrings.UPPER_CASE
                                        }
                                        currentPassword={props.values.password}
                                    />
                                </div>

                                <div className="auth-form-btns">
                                    <Field component={SubmitButton} />
                                    <Field
                                        component={() => (
                                            <SubmitButtonExistAccount
                                                onChangePage={
                                                    this.props.onChangePage
                                                }
                                            />
                                        )}
                                    />
                                </div>
                            </Form>
                        );
                    }}
                />
            </div>
        );
    }
}
